import Vue from 'vue'
import App from './App.vue'
//import 'bootstrap/dist/css/bootstrap.min.css'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'
//import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import router from './router'
import store from './store'

import VueLayers from 'vuelayers'
//import 'vuelayers/lib/style.css' // needs css-loader

Vue.config.productionTip = false
Vue.use(require('vue-moment'))
Vue.use(BootstrapVue)
Vue.use(VueLayers)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
